// ============================================================
// E 组 /m：公众号「管理网站」移动端壳（独立于主站登录态）
// 路由：/m（看板）/m/leads（留言）/m/articles（文章）/m/products（产品）/m/me（我的）
//      /m/login（登录/绑定）/m/callback（网页授权回调）
// ============================================================

import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { AppstoreOutlined, CommentOutlined, FileTextOutlined, ShoppingOutlined, UserOutlined } from '@ant-design/icons';
import { useMAuth } from './mApi';
import MHome from './pages/MHome';
import MLeads from './pages/MLeads';
import MArticles from './pages/MArticles';
import MProducts from './pages/MProducts';
import MMe from './pages/MMe';
import MLogin from './pages/MLogin';
import MCallback from './pages/MCallback';

const TABS = [
  { key: '/m', label: '看板', icon: <AppstoreOutlined /> },
  { key: '/m/leads', label: '留言', icon: <CommentOutlined /> },
  { key: '/m/articles', label: '文章', icon: <FileTextOutlined /> },
  { key: '/m/products', label: '产品', icon: <ShoppingOutlined /> },
  { key: '/m/me', label: '我的', icon: <UserOutlined /> },
];

export function MPageTitle({ title }: { title: string }) {
  return <div style={{ fontSize: 18, fontWeight: 600, padding: '12px 16px 4px' }}>{title}</div>;
}

/** 登录守卫：未登录跳 /m/login */
export function RequireMAuth({ children }: { children: React.ReactNode }) {
  const token = useMAuth((s) => s.token);
  if (!token) return <Navigate to="/m/login" replace />;
  return <>{children}</>;
}

function MTabBar() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  return (
    <div
      data-testid="m-tabbar"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        height: 54,
        display: 'flex',
        background: '#141428',
        borderTop: '1px solid #26264a',
        zIndex: 100,
      }}
    >
      {TABS.map((t) => {
        const active = pathname === t.key || (t.key !== '/m' && pathname.startsWith(t.key));
        return (
          <button
            key={t.key}
            data-testid={`m-tab-${t.key.replace('/m/', '') || 'home'}`}
            onClick={() => nav(t.key)}
            style={{
              flex: 1,
              border: 'none',
              background: 'transparent',
              color: active ? '#4e9eff' : '#8a8aa3',
              fontSize: 11,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              cursor: 'pointer',
            }}
          >
            <span style={{ fontSize: 18 }}>{t.icon}</span>
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

export default function MobileApp() {
  const { pathname } = useLocation();
  const hideTab = pathname.startsWith('/m/login') || pathname.startsWith('/m/callback');
  return (
    <div style={{ minHeight: '100vh', background: '#0f0f1a', color: '#e0e0e0', paddingBottom: hideTab ? 0 : 66 }}>
      <Routes>
        <Route path="" element={<RequireMAuth><MHome /></RequireMAuth>} />
        <Route path="leads" element={<RequireMAuth><MLeads /></RequireMAuth>} />
        <Route path="articles" element={<RequireMAuth><MArticles /></RequireMAuth>} />
        <Route path="products" element={<RequireMAuth><MProducts /></RequireMAuth>} />
        <Route path="me" element={<RequireMAuth><MMe /></RequireMAuth>} />
        <Route path="login" element={<MLogin />} />
        <Route path="callback" element={<MCallback />} />
        <Route path="*" element={<Navigate to="/m" replace />} />
      </Routes>
      {!hideTab && <MTabBar />}
    </div>
  );
}
